/**
 * subscriptionFetchRegistry module.
 * Provides a global singleton Set to track subscription IDs currently being fetched.
 */

/**
 * Set of subscription IDs currently in flight for getSubscription requests.
 * Add an ID before starting a fetch and remove it in finally{}.
 * Used to prevent duplicate requests and manage loading state.
 */
export const inFlightSubs = new Set();
